// Platform-aware shortcut symbols for navigation hints
export const IS_MAC =
  typeof navigator !== 'undefined' &&
  /Mac|iPhone|iPad/.test(navigator.platform);

export const NAV_SHORTCUT_LABELS = {
  up: IS_MAC ? '⌘↑' : 'Ctrl+↑',
  down: IS_MAC ? '⌘↓' : 'Ctrl+↓',
} as const;
